<div *ngIf="image$ | async as image;">

  <button class="mat-dialog-close-button mat-small" color="secondary" mat-icon-button (click)="close()">
    <raf-icon icon="close" size="16px"></raf-icon>
  </button>

  <ng-container *ngIf="images$ | async as images;">

    <swiper [slidesPerView]="1"
            [threshold]="5"
            [pagination]="{type: 'fraction'}"
            [navigation]="true"
            [loop]="true"
            [style.opacity]="threeSixtyActive ? 0 : 1"
            [initialSlide]="initialSlide" >
      <ng-template swiperSlide *ngFor="let image of images$ | async" let-data>
        <raf-image class="flex-grow-1"
                   [attr.data-cy]="data.isActive ? 'dialog-image' : ''" [size]="image.type === 'THREE_SIXTY' ? 'small' : 'normal'"
                   [fromB2c]="image" [targetQuality]="image.type === 'THREE_SIXTY' ? 'preview' : 'high'" [alternativeText]="alternativeText"></raf-image>

        <span *ngIf="image.type === 'THREE_SIXTY'" class="three-sixty-overlay" (click)="openThreeSixty(image)">
          <img src="assets/images/360-degree-icon.svg" alt="360-icon" />
        </span>
      </ng-template>
    </swiper>


    <raf-three-sixty-image *ngIf="threeSixtyActive" [image]="activeThreeSixtyImg" (closeThreeSixty)="closeThreeSixty()"></raf-three-sixty-image>

  </ng-container>
</div>
